export enum OrderStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ON_HOLD = 'on_hold',
}

export type Order = {
  id: string;
  order_number: string;
  customer_name: string;
  customer_email?: string | null;
  customer_phone?: string | null;
  customer_contact?: string | null;
  order_date: string;
  required_by_date?: string | null;
  billing_address_id?: string | null;
  delivery_address_id?: string | null;
  special_instructions?: string | null;
  status: OrderStatus;
  created_by_user_id: string;
  created_at: string;
  updated_at: string;
  // Associations
  billing_address?: any;
  delivery_address?: any;
  created_by_user?: any;
  jobs?: any[];
};

export type OrderCreateInput = {
  customer_name: string;
  customer_email?: string;
  customer_phone?: string;
  customer_contact?: string;
  order_date?: string;
  required_by_date?: string;
  billing_address_id?: string;
  delivery_address_id?: string;
  special_instructions?: string;
};

export type OrderStats = {
  total: number;
  pending: number;
  confirmed: number;
  in_progress: number;
  completed: number;
  cancelled: number;
  on_hold: number;
  overdue: number;
};
